import React, { FC, useEffect, useState } from 'react';
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
    timelineItemClasses,
} from '@mui/lab';
import { useTranslation } from 'react-i18next';
import TimeHelper from '../../../../../utils/time';
import { RefundRestQuery } from '../../../../../services/query';
import { SCUILoading } from '../../../../../atomic/atoms';
import { NoResultFoundComponent } from '../../../../CustomerManagement/components/NoResultFoundComponent/NoResultFoundComponent';

export const SCUIRefundHistory: FC<{ refundId?: any; orderDate?: any }> = ({ refundId, orderDate }) => {
    const [refundHistoryList, setRefundHistoryList] = React.useState<any>();
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const GetRefundListHistory = () => {
        setLoading(true);
        RefundRestQuery.RefundHistory({
            refundId: refundId,
            orderDate: orderDate ? orderDate : null,
        })
            .then((res: any) => {
                if (res.data.result) {
                    setRefundHistoryList(res.data.result);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        GetRefundListHistory();
    }, []);

    return (
        <React.Fragment>
            {refundHistoryList ? (
                <Timeline
                    sx={{
                        [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
                    }}
                >
                    {refundHistoryList &&
                        refundHistoryList.map((item: any, index: number) => (
                            <TimelineItem key={index}>
                                <TimelineSeparator>
                                    <TimelineDot color="primary" />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    {TimeHelper.formatDateHourSecond(item.date)} {item.firstName} {item.lastName}{' '}
                                    <strong>{item.previousStatusName}</strong> &#10148;{' '}
                                    <strong>{item.currentStatusName}</strong>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                </Timeline>
            ) : loading ? (
                <SCUILoading />
            ) : (
                <NoResultFoundComponent errorText={t('refund.paymentHistoryNotFound')} />
            )}
        </React.Fragment>
    );
};
